<template>
  <div class="bg-round bg-fff">
    <div class="container">
      <Bread class="ma-t-30" />
      <el-steps :active="tabshow" simple  finish-status="success" class="ma-tb-40">
        <el-step title="登录"></el-step>
        <el-step title="选择参赛"></el-step>
        <el-step title="参赛联系人"></el-step>
        <el-step title="确认付款"></el-step>
      </el-steps>
    </div>

    <!-- <div id="loading-box">
            加载中
        </div> -->

    <div class="container" id="app" style="padding-bottom: 180px">
      <div class="form" v-if="tabshow == 1">
        <div
          class="row"
          :class="{
            'b-b-red': index == 2,
            'b-b-yellow': index == 3,
            'b-b-blue': index == 4,
          }"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="CategoryName">{{ item.Name }}</div>
          <div
            class="row b-b-eee"
            v-for="(item2, index2) in item.Catrgory"
            :key="index2"
          >
            <div
              class="btn-item col-6 col-md-3"
              v-for="(item3, index3) in item2.List"
              :key="index3"
            >
              <div
                :class="activeIds.includes(item3.Id) ? 'active-item' : ''"
                @click="switchItem(item3.Id)"
              >
                {{ item3.Name }}
              </div>
            </div>
          </div>
        </div>
        <div class="c-999 ma-tb-20">
          短片主竞赛单元为综合评选；展映单元不参与评选；其他为单项奖评选；可以同时报名参加多项评选。
        </div>

        <div class="flex f-jcenter f-center mt-10">
          <!-- <a class="btn-skip" href="./index.html">跳过</a> -->
          <div class="btn-next c-pointer" @click="next(2)">下一步</div>
        </div>
      </div>

      <div class="form1 c-666" v-if="tabshow == 2">
        <div class="t-center c-000 bold fon-18">参赛联系人</div>
        <div class="pa-tb-20 pb-05 b-b-eee">
          <i class="iconfont icon-yonghu"></i>
          <input
            v-model="form.Name"
            type="text"
            placeholder="请输入姓名"
            name=""
            id=""
            class="w-90"
          />
        </div>
        <div class="pa-tb-20 pb-05 b-b-eee">
          <i class="iconfont icon-shouji"></i>
          <input
            v-model="form.Phone"
            type="text"
            placeholder="请输入手机号"
            name=""
            id=""
            class="w-90"
          />
        </div>
        <div class="pa-tb-20 pb-05 b-b-eee">
          <i class="iconfont icon-youxiang"></i>
          <input
            v-model="form.Email"
            type="text"
            placeholder="请输入邮箱"
            name=""
            id=""
            class="w-90"
          />
        </div>
        <div class="ma-t-30">
          <div class="btn-last c-pointer" @click="next(1)">上一步</div>
          <div class="btn-next c-pointer" @click="next(3)">下一步</div>
        </div>
      </div>
    </div>
    <!--<div class="img-a-bg">
      <img
        src="../../img/merge/i2.png"
        alt=""
        srcset=""
        class="img-logo c-pointer"
        onclick="location.href='http://www.shisw.net/'"
      />
    </div>-->
  </div>
</template>
<style lang="scss" scoped>
  @import "../../../css/bootstrap.min.css";
  @import "../../../css/commons.css";
  .mt-10 {
    margin-bottom: 20px;
  }
  .img-a-bg {
    width: 100%;
    height: 285px;
    background: url("../../img/merge/a1.png") no-repeat;
    background-size: cover;
    background-position: center center;
    text-align: right;
    line-height: 285px;
  }

  .img-logo {
    width: 206px;
    height: 206px;
    margin-right: 40px;
  }

  .btn-item {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .btn-item > div {
    padding: 10px;
    text-align: center;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
    cursor: pointer;
  }

  .active-item {
    background-color: #fb004d;
    border: none !important;
    color: #fff;
  }

  .btn-skip {
    width: 300px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
    text-decoration: none;
    color: #666;
  }

  .btn-skip:hover {
    color: #bfbfbf;
  }

  .form .btn-next {
    width: 300px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    border-radius: 10px;
    text-align: center;
    background-color: #fb004d;
    margin-left: 10px;
  }

  .form1 .btn-next {
    width: 300px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    border-radius: 10px;
    text-align: center;
    background-color: #fb004d;
    margin: 20px auto;
  }
  .form1 .btn-last {
    width: 300px;
    height: 50px;
    line-height: 50px;
    color: #fb004d;
    border-radius: 5px;
    text-align: center;
    border: 1px solid #fb004d;
    margin: 0 auto;
  }

  .form {
    border-radius: 10px;
    padding: 40px;
    box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.35);
    margin: 0 auto;
  }
  .form1 {
    width: 300px;
    padding: 20px;
    box-shadow: 0 0 2px 0px #bebebe;
    margin: 0 auto;
  }

  .form1 a {
    text-decoration: none;
    color: inherit;
  }

  .form1 input {
    border: none;
    outline: none;
    margin-left: 10px;
  }
  @media (min-width: 768px) {
    .form1 {
      border-radius: 10px;
      width: 500px;
      padding: 40px;
      box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.35);
      margin: 0 auto;
    }
  }

  @media (max-width: 768px) {
    .form1 {
      border-radius: 10px;
      width: 100%;
      padding: 20px;
      box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.35);
      margin: 0 auto;
    }
  }

  .b-b-eee {
    border-bottom: 1px solid #eee;
  }

  .b-b-red {
    border-bottom: 1px solid red;
  }

  .b-b-yellow {
    border-bottom: 1px solid yellow;
  }

  .b-b-blue {
    border-bottom: 1px solid blue;
  }

  .form-item {
    min-height: 800px;
  }

  .CategoryName {
    text-align: center;
    font-size: 26px;
    color: #fb004d;
    padding-top: 10px;
  }
  .fon-20px {
    font-size: 20px;
  }

  .c-ff9659 {
    color: #ff9659;
  }

  @media (max-width: 768px) {
    .img-a-bg {
      display: none;
    }
  }
</style>
<script>
  import { getCompetitionCatrgory, postCompetitionAdd , getuser } from "../../api.js";
  export default {
    name: "merge",
    data() {
      return {
        list: [],
        activeIds: [],
        tabshow: 1,
        form: {
          Id: "",
          Name: "",
          Email: "",
          Phone: "",
          Token: localStorage.getItem("AccessToken"),
        },
      };
    },
    created() {
      console.log("开始开发");
      this.getCatrgory();
      getuser({ token: this.Token }).then((res) => {
        res=res.data;
        console.log(res)
        if(res.Code==0){
          this.form.Name=res.Data.Name;
          this.form.Phone=res.Data.Phone;
        }
      });
    },

    methods: {
      
      //跳转链接
      toBanerHref() {
        let i = this.$refs.carousel.activeIndex;
        let item = this.bannerlist[i];
        console.log(item);
        if (!item.Href) {
          return;
        } else {
          location.href = item.Href;
        }
      },
      //获取分类数据
      getCatrgory() {
        getCompetitionCatrgory().then((res) => {
          console.log(res);
          this.list = res.data.Data;
        });
      },
      //下一步
      next(val) {
        if (this.activeIds.length == 0 && val == 2) {
          alert("请选择参赛项目");
          return;
        } else if (val == 3) {
          this.form.Id = this.activeIds.join();
          if (!this.form.Name) {
            alert("姓名不能为空哦！");
            return;
          }
          var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
          if (this.form.Phone.length < 1) {
            alert("手机号不能为空哦！");
            return;
          } else if (!reg.test(this.form.Phone)) {
            alert("手机格式不正确！");
            return;
          } else if (this.form.Email.length < 1) {
            alert("邮件不能为空哦！");
            return;
          }
          var emailPat = /^(.+)@(.+)$/;
          var matchArray = this.form.Email.match(emailPat);
          if (matchArray == null) {
            alert("邮件格式错误！");
            return;
          }
          postCompetitionAdd(this.form).then((res) => {
            console.log(res);
            if (res.data.Code == 0) {
              localStorage.setItem("orderKey", res.data.Data.Key);
              this.$router.push("/merge/apply-3");
            }
          });
        } else {
          this.tabshow = val;
        }
      },
      switchItem(id) {
        let i = this.activeIds.indexOf(id);
        if (i == -1) {
          this.activeIds.push(id);
        } else {
          this.activeIds.splice(i, 1);
        }
      },
    },
  };
</script>
